const TARGET_ORIGIN = '*';
export default TARGET_ORIGIN;
